/* ==========================================================================
   Hattie B's Boutique - cart drawer behaviour.

   Three jobs only: the upsell "Add" button, the upsell variant price swap, the
   upsell arrows, and removing a line. Everything else (quantity stepper, cart
   rebuild, subtotal, bubble count, drawer open and close) is already handled by
   theme.CartForm and theme.CartDrawer in assets/mrk.js, and this file
   deliberately does not duplicate any of it.

   Two hard rules, both learned from the rollback:
   1. NO MutationObserver, and nothing that re-renders the cart off DOM changes.
      A previous build did that and blanked the storefront. Re-rendering happens
      only through templates/cart.ajax.liquid, which the theme scrapes.
   2. Every listener is delegated from the document, so markup replaced by the
      theme's ajax repaint keeps working without being re-bound.
   ========================================================================== */
(function () {
  "use strict";

  var ROOT =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    "/";

  function addUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) {
      return theme.routes.cartAdd;
    }
    return ROOT.replace(/\/$/, "") + "/cart/add.js";
  }

  function changeUrl() {
    if (window.theme && theme.routes && theme.routes.cartChange) {
      return theme.routes.cartChange;
    }
    return ROOT.replace(/\/$/, "") + "/cart/change.js";
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, data: data };
      });
    });
  }

  /* Hand control back to the theme so it re-renders from cart.ajax.liquid.
     In the drawer, ajaxProduct:added also opens the drawer, which is what a
     shopper expects after an add. On the cart page nothing listens for that, so
     cart:build is used instead. */
  function askThemeToRebuild(cart) {
    var hasDrawer = !!document.getElementById("CartDrawerForm");

    if (hasDrawer) {
      document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
    } else {
      document.dispatchEvent(new CustomEvent("cart:build"));
    }

    document.dispatchEvent(
      new CustomEvent("cart:updated", { detail: { cart: cart || null } })
    );
  }

  function scrollStep(track) {
    var card = track.querySelector(".hb-up__card");
    if (!card) {
      return Math.round(track.clientWidth * 0.8);
    }
    return card.offsetWidth + 10;
  }

  function syncCongrats(count) {
    var show = typeof count === "number" ? count > 0 : false;
    document.querySelectorAll("[data-hb-congrats]").forEach(function (el) {
      if (show) {
        el.removeAttribute("hidden");
      } else {
        el.setAttribute("hidden", "");
      }
    });
  }

  document.addEventListener("cart:updated", function (evt) {
    var cart = evt && evt.detail && evt.detail.cart;
    if (cart && typeof cart.item_count === "number") {
      syncCongrats(cart.item_count);
    }
  });

  /* Upsell add, upsell arrows, remove line -------------------------------- */

  document.addEventListener("click", function (evt) {
    var target = evt.target;
    if (!target || !target.closest) {
      return;
    }

    var nav = target.closest("[data-hb-carousel]");
    if (nav) {
      var viewport = nav.closest(".hb-up__viewport");
      var track = viewport && viewport.querySelector("[data-hb-carousel-track]");
      if (track) {
        var amount = scrollStep(track);
        track.scrollBy({
          left: nav.getAttribute("data-hb-carousel") === "prev" ? -amount : amount,
          behavior:
            window.HB && HB.prefersReducedMotion && HB.prefersReducedMotion()
              ? "auto"
              : "smooth"
        });
      }
      return;
    }

    var addBtn = target.closest("[data-hb-upsell-add]");
    if (addBtn) {
      evt.preventDefault();

      var card = addBtn.closest("[data-hb-upsell-item]");
      var field = card && card.querySelector("[data-hb-upsell-variant]");
      var id = field && field.value;
      if (!id || addBtn.hasAttribute("disabled")) {
        return;
      }

      var label = addBtn.querySelector("[data-hb-upsell-add-label]");
      var original = label ? label.textContent : "";

      addBtn.setAttribute("disabled", "disabled");
      if (label) {
        label.textContent = "Adding";
      }

      postJSON(addUrl(), { id: id, quantity: 1 })
        .then(function (result) {
          if (!result.ok) {
            window.alert(
              (result.data && result.data.description) ||
                "That item could not be added."
            );
            return;
          }
          askThemeToRebuild(result.data);
        })
        .catch(function () {
          window.alert("That item could not be added.");
        })
        .then(function () {
          addBtn.removeAttribute("disabled");
          if (label) {
            label.textContent = original || "Add";
          }
        });
      return;
    }

    var remove = target.closest("[data-hb-remove]");
    if (remove) {
      var key = remove.getAttribute("data-key");
      if (!key) {
        return;
      }

      /* The href is a real /cart/change fallback, so only take over when
         fetch is available. */
      if (!window.fetch) {
        return;
      }

      evt.preventDefault();

      var line = remove.closest(".hb-line");
      if (line) {
        line.style.opacity = "0.5";
      }

      postJSON(changeUrl(), { id: key, quantity: 0 })
        .then(function (result) {
          if (!result.ok) {
            if (line) {
              line.style.opacity = "";
            }
            return;
          }
          document.dispatchEvent(new CustomEvent("cart:build"));
          document.dispatchEvent(
            new CustomEvent("cart:updated", { detail: { cart: result.data } })
          );
        })
        .catch(function () {
          if (line) {
            line.style.opacity = "";
          }
        });
    }
  });

  /* Upsell variant swap. The option carries prices already formatted by the
     Liquid money filter, so no price is ever built in JS. */
  document.addEventListener("change", function (evt) {
    var select = evt.target;
    if (!select || !select.matches || !select.matches("select[data-hb-upsell-variant]")) {
      return;
    }

    var card = select.closest("[data-hb-upsell-item]");
    var option = select.options[select.selectedIndex];
    if (!card || !option) {
      return;
    }

    var priceEl = card.querySelector("[data-hb-upsell-price]");
    var compareEl = card.querySelector("[data-hb-upsell-compare]");

    if (priceEl && option.dataset.price) {
      priceEl.textContent = option.dataset.price;
    }

    if (compareEl) {
      if (option.dataset.compare) {
        compareEl.textContent = option.dataset.compare;
        compareEl.classList.remove("is-hidden");
      } else {
        compareEl.textContent = "";
        compareEl.classList.add("is-hidden");
      }
    }
  });

  /* Send shoppers to native Shopify checkout instead of the Shop Pay
     login / email-recognition intercept. Cards, Apple Pay and Google Pay
     stay available on the checkout page. */
  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.querySelector) {
      return;
    }
    if (!form.querySelector(".cart__checkout")) {
      return;
    }
    if (event.defaultPrevented) {
      return;
    }
    event.preventDefault();
    var root =
      (window.Shopify && Shopify.routes && Shopify.routes.root) || ROOT || "/";
    window.location.href =
      root.replace(/\/?$/, "/") + "checkout?skip_shop_pay=true";
  });
})();
